import { create } from 'zustand';

/**
 * MKPC-3616: 본인인증 미완료(생년월일 미상, adultStatus=UNVERIFIED) 회원이
 * 19금 상품을 이용하려 할 때 띄우는 "본인인증 안내" 다이얼로그 전역 상태.
 */
interface Store {
  opened: boolean;
  open: () => void;
  close: () => void;
}

const useAdultAuthDialogStore = create<Store>((set) => ({
  opened: false,
  open: () => set({ opened: true }),
  close: () => set({ opened: false }),
}));

export default useAdultAuthDialogStore;
